import "./ActionIcon.scss";

interface IActionIconProps {
  icon: string;
  onClick?: () => void;
  color?: string;
  disabled?: boolean;
}

const ActionIcon = (props: IActionIconProps) => {

  const classes = `action-icon${props.onClick ? ` clickable` : ``}${props.color ? ` ${props.color}` : ``}${props.disabled ? ` disabled` : ``}`;

  const handleClick = (e: any) => {
    if (props.disabled) {
      e.stopPropagation();
      e.preventDefault();
    } else if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <div className={classes} onClick={handleClick}>
      <i className={props.icon}></i>
    </div>
  )
}

export default ActionIcon;